/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ProtocolDto } from './ProtocolDto';
import {
    ProtocolDtoFromJSON,
    ProtocolDtoFromJSONTyped,
    ProtocolDtoToJSON,
} from './ProtocolDto';

/**
 * 
 * @export
 * @interface ODataPostProcessedResultsOfProtocolDto
 */
export interface ODataPostProcessedResultsOfProtocolDto {
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfProtocolDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ProtocolDto>}
     * @memberof ODataPostProcessedResultsOfProtocolDto
     */
    value?: Array<ProtocolDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ODataPostProcessedResultsOfProtocolDto
     */
    $type?: ODataPostProcessedResultsOfProtocolDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfProtocolDto
     */
    odataCount?: number;
}


/**
 * @export
 */
export const ODataPostProcessedResultsOfProtocolDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoODataPostProcessedResults1PtwPtw100AppZeroApplicationSharedProtocolsDtoProtocolDtoPtwPtw100AppZeroApplicationSharedPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ODataPostProcessedResults`1[[Ptw.Ptw100.AppZero.Application.Shared.Protocols.Dto.ProtocolDto, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ODataPostProcessedResultsOfProtocolDtoTypeEnum = typeof ODataPostProcessedResultsOfProtocolDtoTypeEnum[keyof typeof ODataPostProcessedResultsOfProtocolDtoTypeEnum];


/**
 * Check if a given object implements the ODataPostProcessedResultsOfProtocolDto interface.
 */
export function instanceOfODataPostProcessedResultsOfProtocolDto(value?: unknown): value is ODataPostProcessedResultsOfProtocolDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ODataPostProcessedResultsOfProtocolDtoTypeEnum)[0];
}

export function ODataPostProcessedResultsOfProtocolDtoFromJSON(json: any): ODataPostProcessedResultsOfProtocolDto {
    return ODataPostProcessedResultsOfProtocolDtoFromJSONTyped(json, false);
}

export function ODataPostProcessedResultsOfProtocolDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ODataPostProcessedResultsOfProtocolDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'value': !exists(json, 'value') ? undefined : (json['value'] === null ? null : (json['value'] as Array<any>).map(ProtocolDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
        'odataCount': !exists(json, '@odata.count') ? undefined : json['@odata.count'],
    };
}

export function ODataPostProcessedResultsOfProtocolDtoToJSON(value?: ODataPostProcessedResultsOfProtocolDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'totalCount': value.totalCount,
        'value': value.value === undefined ? undefined : (value.value === null ? null : (value.value as Array<any>).map(ProtocolDtoToJSON)),
        '$type': value.$type,
        '@odata.count': value.odataCount,
    });
}

